import { useEffect } from "react";

/**
 * Registra o service worker (gerado pelo vite-plugin-pwa a partir de
 * src/client/sw.ts). Só em produção, para não cachear o dev. Silencioso
 * em erro (modo privado, navegador sem suporte).
 */
export function ServiceWorkerRegister() {
  useEffect(() => {
    if (!import.meta.env.PROD || !("serviceWorker" in navigator)) return;
    navigator.serviceWorker.register("/sw.js", { scope: "/", type: "module" }).catch((err) => {
      console.warn("Falha ao registrar service worker:", err);
    });
  }, []);
  return null;
}
